import React from 'react'

import RadioToggle from '../../generic/toggles/radioToggle'
import Error from '../../generic/Error'

export default ({ isIneligible, isError, saveQuestionResponse, getQuestionResponse, amQ, addImpressions }) => {
  const resqp79 = getQuestionResponse('qp/79').v

  return (
    <>
      <RadioToggle
        pills={['Yes', 'No']}
        testId={'vd-bt-twomorekeysquestion'}
        selectedIndex={resqp79}
        onClickItem={(i, isSelected) => {
          saveQuestionResponse('qp/79', i)
        }}
      />
      {!isIneligible && <Error isError={isError} id={'twomorekeysquestion-error'} testId={`vd-lb-twomorekeysquestion-error`} text={'Please select whether you have two or more keys. '} />}
    </>
  )
}
